import { DashboardItem } from './dashboard-item.model';
import { Kpi } from './kpi.model';
import { Layout } from './layout.model';

export interface Dashboard {
  layout?: Layout;
  dashboardId?: number;
  dashboardItems: DashboardItem[];
  kpi?: Kpi;
}

export enum DashboardType {
  detailDashboard = 'detailDashboard',
  mainDashboard = 'mainDashboard',
}

export interface DashboardInfoModel {
  subjectAreaId: number;
  layoutId: number;
  kpiId: number;
}
